import _regenerator from "/var/lib/jenkins/workspace/event-xsj-260120-vue/node_modules/.pnpm/@babel+runtime@7.28.4/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/var/lib/jenkins/workspace/event-xsj-260120-vue/node_modules/.pnpm/@babel+runtime@7.28.4/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/var/lib/jenkins/workspace/event-xsj-260120-vue/node_modules/.pnpm/@babel+runtime@7.28.4/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.error.to-string.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.array-buffer.constructor.js";
import "core-js/modules/es.array-buffer.slice.js";
import "core-js/modules/es.array-buffer.detached.js";
import "core-js/modules/es.array-buffer.transfer.js";
import "core-js/modules/es.array-buffer.transfer-to-fixed-length.js";
import "core-js/modules/es.date.to-json.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.reduce.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.typed-array.uint8-array.js";
import "core-js/modules/es.typed-array.at.js";
import "core-js/modules/es.typed-array.copy-within.js";
import "core-js/modules/es.typed-array.every.js";
import "core-js/modules/es.typed-array.fill.js";
import "core-js/modules/es.typed-array.filter.js";
import "core-js/modules/es.typed-array.find.js";
import "core-js/modules/es.typed-array.find-index.js";
import "core-js/modules/es.typed-array.find-last.js";
import "core-js/modules/es.typed-array.find-last-index.js";
import "core-js/modules/es.typed-array.for-each.js";
import "core-js/modules/es.typed-array.includes.js";
import "core-js/modules/es.typed-array.index-of.js";
import "core-js/modules/es.typed-array.iterator.js";
import "core-js/modules/es.typed-array.join.js";
import "core-js/modules/es.typed-array.last-index-of.js";
import "core-js/modules/es.typed-array.map.js";
import "core-js/modules/es.typed-array.reduce.js";
import "core-js/modules/es.typed-array.reduce-right.js";
import "core-js/modules/es.typed-array.reverse.js";
import "core-js/modules/es.typed-array.set.js";
import "core-js/modules/es.typed-array.slice.js";
import "core-js/modules/es.typed-array.some.js";
import "core-js/modules/es.typed-array.sort.js";
import "core-js/modules/es.typed-array.to-locale-string.js";
import "core-js/modules/es.typed-array.to-reversed.js";
import "core-js/modules/es.typed-array.to-sorted.js";
import "core-js/modules/es.typed-array.to-string.js";
import "core-js/modules/es.typed-array.with.js";
import "core-js/modules/esnext.uint8-array.set-from-base64.js";
import "core-js/modules/esnext.uint8-array.set-from-hex.js";
import "core-js/modules/esnext.uint8-array.to-base64.js";
import "core-js/modules/esnext.uint8-array.to-hex.js";
import "core-js/modules/web.atob.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-exception.constructor.js";
import "core-js/modules/web.dom-exception.stack.js";
import "core-js/modules/web.dom-exception.to-string-tag.js";
// import User from "@/api/user.js";
/**
 * 地址栏query 处理
 * @param href `string`  需要qs的url
 * @param ignoreHash `boolean` 是否忽略hash后面的参数
 * @default (window.location.href, false)
 * @returns
 */
import Vue from "vue";
import Cookie from "js-cookie";
import i18nwordConfig, { LANG_MAPS } from "@/lib/i18nwordConfig";
import request from "@/utils/request";
// import { isAppEnv , appDownload } from "@/components/basic/parts/kuroJsbridge/index";
// import { useInfoStore } from "@/stores/info";
// const { getOssSign, uploadOss } = useInfoStore();
import { v4 as uuidv4 } from "uuid";
export var qs = function qs() {
  var href = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.location.href;
  var ignoreHash = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var result = {};
  var param = null;
  var reg = /[?&](.*?)=([^&#]*)/g;
  if (ignoreHash) {
    href = href.replace(/#.*?$/, "");
  }
  param = reg.exec(href);
  while (param) {
    // 上面已经decode过，不需要重复decode，过度decode会导致其它问题
    // result[param[1]] = param[2];
    try {
      result[param[1]] = decodeURIComponent(param[2]);
    } catch (e) {
      try {
        result[param[1]] = unescape(param[2]);
      } catch (escapeErr) {
        // eslint-disable-next-line prefer-destructuring
        result[param[1]] = param[2];
      }
      // result[param[1]] = `Decode Error: ${param[2]}`;
    }
    param = reg.exec(href);
  }
  return result;
};
export var QS = qs();
var getLocation = function getLocation(url) {
  var a = document.createElement("a");
  a.href = url;
  return a;
};
var getOriginByTag = function getOriginByTag(tag) {
  var origin = tag.origin;
  if (!origin) {
    origin = tag.protocol + "//" + tag.hostname + (tag.port ? ":" + tag.port : "") + "/";
  }
  return origin;
};
export function addParamsToUrl(url, params) {
  var isPre = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var u = getLocation(url);
  var href = u.href,
    pathname = u.pathname,
    hash = u.hash;
  var mergeParams = isPre ? _objectSpread(_objectSpread({}, params), qs(href, true)) : _objectSpread(_objectSpread({}, qs(href, true)), params);
  var str = Object.keys(mergeParams).reduce(function (ta, va) {
    return mergeParams[va] ? ta.concat("".concat(!ta ? "?" : "&").concat(va, "=").concat(mergeParams[va])) : ta;
  }, "");
  var origin = getOriginByTag(u);
  return "".concat(origin).concat(pathname).concat(str).concat(hash);
}
function getBrowserInfo() {
  var deviceType;
  var browser = {
    versions: function () {
      var u = navigator.userAgent;
      // const app = navigator.appVersion;
      return {
        // 移动终端浏览器版本信息
        trident: u.indexOf("Trident") > -1,
        // IE内核
        presto: u.indexOf("Presto") > -1,
        // opera内核
        webKit: u.indexOf("AppleWebKit") > -1,
        // 苹果、谷歌内核
        gecko: u.indexOf("Gecko") > -1 && u.indexOf("KHTML") === -1,
        // 火狐内核
        mobile: !!u.match(/AppleWebKit.*Mobile.*/),
        // 是否为移动终端
        ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/),
        // ios终端
        android: u.indexOf("Android") > -1 || u.indexOf("Linux") > -1,
        // android终端或者uc浏览器
        iPhone: u.indexOf("iPhone") > -1,
        // 是否为iPhone或者QQHD浏览器
        iPad: u.indexOf("iPad") > -1,
        // 是否iPad
        webApp: u.indexOf("Safari") === -1 // 是否web应该程序，没有头部与底部
      };
    }(),
    language: (navigator.browserLanguage || navigator.language).toLowerCase()
  };
  if (browser.versions.mobile || browser.versions.ios || browser.versions.android || browser.versions.iPhone || browser.versions.iPad) {
    deviceType = "mobile";
  } else {
    deviceType = "pc";
  }
  return {
    deviceType: deviceType,
    language: browser.language
  };
}
export var track = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(_ref) {
    var category, action, label, value, extra, host;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          category = _ref.category, action = _ref.action, label = _ref.label, value = _ref.value, extra = _ref.extra;
          host = process.env.NODE_ENV !== "production" ? 'https://api-test.weekver.fun' : 'https://api.weekver.fun';
          return _context.a(2, request.post("".concat(host, "/report/report"), {
            event_id: "m20260122klh7g4tvbd",
            company_id: 3,
            project_id: "xishanju",
            sdk_version: 1,
            source_type: 1,
            timestamp: Math.floor(Date.now() / 1000),
            page_info: JSON.stringify({
              app_id: 1,
              page_id: 1,
              page_url: window.document.location.href,
              referer: window.document.referrer
            }),
            event_info: JSON.stringify({
              eventCategory: category,
              eventAction: action,
              eventLabel: label,
              eventValue: value,
              extra_info: extra
            }),
            user_info: JSON.stringify({
              lang: getRealLang(),
              user_agent: window.navigator.userAgent
            })
          }, {
            ignoreError: true
          }));
      }
    }, _callee);
  }));
  return function track(_x) {
    return _ref2.apply(this, arguments);
  };
}();
var langList = null;
export var initLang = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
    var lang, _yield$request$post, data, _t;
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.p = _context2.n) {
        case 0:
          lang = getRealLang();
          Vue.prototype.$lang = lang;
          if (langList) {
            _context2.n = 4;
            break;
          }
          _context2.p = 1;
          _context2.n = 2;
          return request.post(process.env.VUE_APP_I18N_URL, {
            event_id: "m20260122klh7g4tvbd",
            company_id: 3,
            module: "1",
            lang: lang
          });
        case 2:
          _yield$request$post = _context2.v;
          data = _yield$request$post.data;
          langList = data;
          _context2.n = 4;
          break;
        case 3:
          _context2.p = 3;
          _t = _context2.v;
          langList = {};
        case 4:
          Vue.prototype.$getI18nWord = function (key) {
            try {
              var rootElement = document.documentElement;
              rootElement.setAttribute("lang", lang);
              return _objectSpread(_objectSpread({}, i18nwordConfig[lang]), langList)[key];
            } catch (error) {
              return "";
            }
          };
        case 5:
          return _context2.a(2);
      }
    }, _callee2, null, [[1, 3]]);
  }));
  return function initLang() {
    return _ref3.apply(this, arguments);
  };
}();
export var getRealLang = function getRealLang() {
  var _getBrowserInfo$langu;
  if (!IS_SEA) {
    return "zh-cn";
  }
  var qsLang = LANG_MAPS.find(function (item) {
    return item.value.includes(QS.lang);
  });
  var browserLang = LANG_MAPS.find(function (item) {
    return item.value.includes(getBrowserInfo().language);
  });
  var bLang = browserLang ? browserLang.value : "en-us";
  var cookieLang = Cookie.get("mi18nLang");
  var curlang = "";
  if (((_getBrowserInfo$langu = getBrowserInfo().language) === null || _getBrowserInfo$langu === void 0 ? void 0 : _getBrowserInfo$langu.toLowerCase()) === "zh-hk") {
    curlang = "zh-tw";
  }
  var realLang = (qsLang === null || qsLang === void 0 ? void 0 : qsLang.value) || cookieLang || curlang || bLang;
  return LANG_MAPS.find(function (item) {
    return item.value === realLang;
  }) ? realLang : "en-us";
};
export function base64ToFile(base64String, fileName) {
  // 分割base64数据，获取MIME类型和实际数据
  var arr = base64String.split(",");
  var mimeMatch = arr[0].match(/:(.*?);/);
  // 如果无法解析MIME类型，默认使用application/octet-stream
  var mimeType = mimeMatch ? mimeMatch[1] : "application/octet-stream";
  // 解码base64数据为二进制字符串
  var bstr = atob(arr[1]);
  var n = bstr.length;
  // 创建Uint8Array数组存储二进制数据
  var u8arr = new Uint8Array(n);
  // 填充二进制数据
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  // 创建并返回File对象
  // 第三个参数是可选的，用于指定文件的最后修改时间
  return new File([u8arr], fileName, {
    type: mimeType
  });
}
// export const getUrlByBase64 = async (url: string) => {
//   const uuid = uuidv4();
//   const fileData = base64ToFile(url, `kl-event-${+new Date()}${uuid}.jpg`);
//   const data = await getOssSign();
//   const key = `${data.dir}/${fileData.name}`;
//   const formData = new FormData();
//   formData.append("success_action_status", "200");
//   formData.append("policy", data.policy);
//   formData.append("x-oss-signature", data.signature);
//   formData.append("x-oss-signature-version", "OSS4-HMAC-SHA256");
//   formData.append("x-oss-credential", data.x_oss_credential);
//   formData.append("x-oss-date", data.x_oss_date);
//   formData.append("key", key); // 文件名 这里用playerId+"/"+时间戳+文件名后缀
//   formData.append("x-oss-security-token", data.security_token);
//   formData.append("file", fileData); // file 必须为最后一个表单域
//   await uploadOss(data.host, formData);
//   return `${data.host}/${key}`;
// };
/**
 * 基于 Base64 字符串下载图片
 * @param {string} base64Data - 完整的 Base64 图片字符串（格式如：data:image/png;base64,...）
 * @param {string} [fileName] - 可选，下载的文件名（不带后缀则自动根据图片类型补充）
 */
export function downloadImageByBase64(base64Data) {
  var fileName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
  downloadImage(base64Data);
}
export function urlToBase64(_x2) {
  return _urlToBase.apply(this, arguments);
}
/**
 * 预加载字体包
 * @param fonts 字体配置数组
 * @param onAllLoaded 所有字体加载完成的回调函数
 * @param onError 单个字体加载出错的回调函数
 */
function _urlToBase() {
  _urlToBase = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(url) {
    var response, blob, _t2;
    return _regenerator().w(function (_context3) {
      while (1) switch (_context3.p = _context3.n) {
        case 0:
          _context3.p = 0;
          _context3.n = 1;
          return fetch(url);
        case 1:
          response = _context3.v;
          if (response.ok) {
            _context3.n = 2;
            break;
          }
          throw new Error("资源获取失败");
        case 2:
          _context3.n = 3;
          return response.blob();
        case 3:
          blob = _context3.v;
          return _context3.a(2, new Promise(function (resolve, reject) {
            var reader = new FileReader();
            reader.onloadend = function () {
              // result是DataURL格式（包含Base64）
              resolve(reader.result);
            };
            reader.onerror = reject;
            reader.readAsDataURL(blob); // 核心方法：将Blob转为DataURL
          }));
        case 4:
          _context3.p = 4;
          _t2 = _context3.v;
          console.error("转换失败：", _t2);
          return _context3.a(2, null);
      }
    }, _callee3, null, [[0, 4]]);
  }));
  return _urlToBase.apply(this, arguments);
}
export function preloadFonts(fonts, onAllLoaded, onError) {
  // 检查浏览器是否支持FontFace API
  if (!window.FontFace) {
    console.warn("当前浏览器不支持FontFace API，无法预加载字体");
    onAllLoaded === null || onAllLoaded === void 0 || onAllLoaded([]);
    return;
  }
  var loadedFonts = [];
  var totalFonts = fonts.length;
  fonts.forEach(function (font) {
    var family = font.family,
      src = font.src;
    try {
      // 创建FontFace实例
      var fontFace = new FontFace(family, src);
      // 加载字体
      fontFace.load().then(function (loadedFace) {
        // 将字体添加到文档中
        document.fonts.add(loadedFace);
        loadedFonts.push(family);
        // 检查是否所有字体都已加载完成
        if (loadedFonts.length === totalFonts) {
          onAllLoaded === null || onAllLoaded === void 0 || onAllLoaded([].concat(loadedFonts));
        }
      }).catch(function (error) {
        console.error("\u5B57\u4F53 \"".concat(family, "\" \u52A0\u8F7D\u5931\u8D25:"), error);
        onError === null || onError === void 0 || onError(family, error);
      });
    } catch (error) {
      console.error("\u521B\u5EFA\u5B57\u4F53 \"".concat(family, "\" \u5B9E\u4F8B\u5931\u8D25:"), error);
      onError === null || onError === void 0 || onError(family, error);
    }
  });
}
export function downloadImage(_x3) {
  return _downloadImage.apply(this, arguments);
}
// window.cc = () => {
// const ossImageUrl = "https://20250917.oss-accelerate.aliyuncs.com/MTIzNDU2Mg==/weekver-event-1761133653795f7c65a22-0575-426a-9e91-a7222e36ae72.jpg";
// // 发起跨域请求
// fetch(ossImageUrl, { mode: "cors" }) // 显式指定跨域模式
//   .then(response => {
//     if (response.ok) {
//       console.log("请求成功，无跨域限制（或 CORS 配置正确）");
//     } else {
//       console.log("请求成功但状态异常（非跨域问题）");
//     }
//   })
//   .catch(error => {
//     if (error.message.includes("CORS") || error.name === "TypeError") {
//       console.log("存在跨域限制：", error.message);
//     } else {
//       console.log("其他错误：", error);
//     }
//   });
// }
function _downloadImage() {
  _downloadImage = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(imageUrl) {
    var fileName,
      uuid,
      link,
      name,
      _args4 = arguments;
    return _regenerator().w(function (_context4) {
      while (1) switch (_context4.n) {
        case 0:
          fileName = _args4.length > 1 && _args4[1] !== undefined ? _args4[1] : "";
          // if (isAppEnv()) {
          //   let urls = ''
          //   if (imageUrl.includes('oss')) {
          //     urls = require(`@images/ossimg/${imageUrl.split('MTIzNDU2Mg==/')[1]}`)
          //   }
          //   const url = await urlToBase64(urls || imageUrl) as any;
          //   url && appDownload(url)
          //   return
          // }
          uuid = uuidv4(); // 创建一个隐藏的a标签
          link = document.createElement("a"); // 处理文件名（默认使用链接中的文件名或随机名称）
          name = fileName;
          if (!name) {
            // 从URL中提取文件名
            name = "kl-event-".concat(+new Date()).concat(uuid, ".jpg") || "downloaded-image";
          }
          // 设置a标签属性
          link.href = imageUrl;
          // 设置下载文件名（浏览器会自动添加正确的扩展名）
          link.download = name;
          // 将a标签添加到页面并触发点击
          document.body.appendChild(link);
          link.click();
          // 清理：移除a标签
          setTimeout(function () {
            document.body.removeChild(link);
          }, 0);
        case 1:
          return _context4.a(2);
      }
    }, _callee4);
  }));
  return _downloadImage.apply(this, arguments);
}